import React from 'react';
import { di } from 'react-magnetic-di';
import { LazySuspense, lazyForPaint } from 'react-loosely-lazy';
import { Skeleton } from '@pole-journal-web/app-screen-skeleton';

const AsyncRewards = lazyForPaint(
    () => import(/* webpackChunkName: "async-rewards" */ './index')
        .then(({ Rewards }) => Rewards)
);

export const Rewards = () => {
    di(AsyncRewards, LazySuspense, Skeleton);

    return (
        <LazySuspense fallback={<Skeleton />}>
            <AsyncRewards />
        </LazySuspense>
    );
};
